import { Capacitor } from "@capacitor/core";
import { isVpnConnected } from "@/services/vpnCheck";

/**
 * Global navigation guard that enforces VPN connectivity for non-local environments.
 *
 * Skips the check entirely when VITE_ENV is 'local'.
 * Skips the check when running on a native device (iOS/Android).
 * Allows navigation to the vpn-required page itself to avoid redirect loops.
 */
const vpn = async (to) => {
    if (import.meta.env.VITE_ENV === 'local') {
        return;
    }

    if (Capacitor.isNativePlatform()) {
        return;
    }

    if (to.name === 'vpn-required') {
        return;
    }

    const connected = await isVpnConnected();

    if (!connected) {
        return { name: 'vpn-required' };
    }
};

export default vpn;
